<template>
  <v-select
      multiple
      v-model="model"
      :options="allMonetaryActions"
      :reduce="m=>m.value"
      v-bind="selectProps"
      :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'MonetaryActionSelectBox',
  props: {
    value: {
      required: false,
    },
    selectProps:{
      default: () => ({})
    },
    disabled:{
      type: Boolean,
      default: () => false
    },
    clearable:{
      type: Boolean,
      default: () => false
    },
    multiple:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    },
    allMonetaryActions(){
      let actions = this.$t('monetaryActions');
      // De-duplicate by label: the static data has two entries that resolve to
      // "Balance" (CREDIT_LINE + the malformed "DEBIT ") and two to "Bonus"
      // (BONUS + CREDIT). Keep the first valid one of each label so the filter
      // doesn't show the duplicate pair (whose values error on the backend).
      const seen = new Set();
      return Object.keys(actions).reduce((out, key) => {
        const label = actions[key].name;
        if (seen.has(label)) return out;
        seen.add(label);
        out.push({ label, value: key });
        return out;
      }, []);
    },
    _selectProps(){
      let props = {...this.$props, ...this.selectProps}
      delete props.value
      delete props.options
      delete props.label
      delete props.reduce
      return props
    }
  }
};
</script>

<style scoped>

</style>
